export const BUNDLE_TYPE = {
  PAYG: 'BASIC',
  PLAY: 'MEDIA'
}
